import styled from 'styled-components';

export const Title = styled.h1 `
    width: 790px;

    font-size: 24px;
    color: #0c326f;

    @media (max-width: 1000px) {
        font-size: 18px;
        width: 380px;
        margin-right: 30px;
    }
`;

export const Text = styled.label `
    font-size: 14px;
    font-weight: normal;
    color: #333333;
`;

export const Mandatory = styled.span `
    padding-left: 10px; 
    color: red;
    font-weight: 900;
`;

export const GlobalContainer = styled.div `
    //127px(altura do footer) ou 80px(altura do footer2)
    padding: 0px 0px 80px;
`;

export const TitleContainer = styled.div `
    padding: 30px 0px 0px;
    display: flex;
`;

export const ContentContainer = styled.div `
    display: flex;
    justify-content: center;
    max-width: 790;
    margin: 0px auto;
`;

export const ContentContainerBlock = styled.div `
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;
`;

export const ContentContainerBlock2 = styled.div `
    display: flex;
    flex-direction: column;
`;


export const ContentContainer1 = styled.div `
    width: 70%;
    margin-left: 10px;
    padding: 0px 0px 15px;
`;

export const ContentContainer11 = styled.div `
    display: grid;
    margin-bottom: 20px;
`;

export const ContentContainer12 = styled.div `
    display: grid;
    margin-top: 2px;
    margin-bottom: 20px;
    border: 1px solid #888;
    border-radius: 6px;
`;

export const ContentContainer13 = styled.div `
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
`;

export const ContentContainer14 = styled.div `
    margin-right: 60%;
    margin-bottom: 20px;
`;

export const ContentContainer15 = styled.div `
    margin-bottom: 20px;
`;

export const SelectContainer = styled.div `
    width: 50%;
    height: 64px;
    display: grid;
    
    //border: 1px solid;
    //border-color: red;
`;

export const SelectContainerLeftMargin = styled.div `
    margin-left: 10px;
    width: 30%;
    height: 64px;
    display: grid;
    
    //border: 1px solid;
    //border-color: red;
`;

export const PaginationContainer = styled.div `
    margin-top: 20px;
    padding: 0px 30px;

    //border: 1px solid;
    //border-color: red;
`;

export const SelectPagesContainer = styled.div `
    width: 55px;
    height: 64px;
    display: grid;

    //border: 1px solid;
    //border-color: red;
`;

export const ContentContainer2 = styled.div `
    width: 380px;
`;

export const ContentContainer4 = styled.div `
    margin: 20px auto;
    max-width: 790px; 
`;

export const ContentContainerButtons = styled.div `
    padding: 20px 0 20px;
    text-align: right;

    button:nth-child(2){ /*-pegando o segundo button desta div-*/
        margin-left: 10px;
    }
`;

export const ContentContainerButtonsWithMarginLeft = styled.div `
    padding: 20px 0px 20px;
    text-align: right;
    margin-left: 5em;

    
`;

export const ContainerLoad = styled.div `
    
    position: absolute;
    z-index: 9999;

    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    #load {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -44px;
        margin-left: -22px;
    }

`;

export const InputContainerCheckbox = styled.div`
  margin-right: 30px;
  display: flex;
  align-items: center;

  input[type='checkbox'] {
    -moz-appearance: none;
    -webkit-appearance: none;
    -o-appearance: none;
    outline: none;
    content: none;
  }

  input[type='checkbox']:before {
    font-family: Ampersand, Helvetica, sans-serif;
    content: '✓';
    font-size: 20px;
    color: transparent !important;

    text-align: center;

    display: flex;
    align-items: center;
    width: 20px;
    height: 20px;
    border: 1px solid #888;
    padding-left: 1px;
    margin-right: 15px;
    border-radius: 25%;
  }

  input[type='checkbox']:checked:before {
    color: green !important;
  }
`;